import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';

export interface Contact {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	notify: boolean;
}

@Component({
	selector: 'change-password-dialog',
	templateUrl: './change-password-dialog.component.html',
	styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent implements OnInit {
	@ViewChild('currentPassword') currentPasswordField: any;

	title: string;
	showLoading: boolean = false;
	hasError: boolean = false;
	errorMessage: string;
	currentStrength: number;

	constructor(public dialogRef: MatDialogRef<ChangePasswordDialogComponent>, private _userService: UserService, @Inject(MAT_DIALOG_DATA) public data: any) {
		this.title = data.title
		data.newPassword = data.confirmPassword = data.currentPassword = '';
	}

	ngAfterViewInit() {
		// this is a well known hack to get a field to focus upon showing it
		setTimeout(() => {
			this.currentPasswordField.valueAccessor._elementRef.nativeElement.focus();
		});
	}

	ngOnInit() {
	}

	save() {
		this.showLoading = true;
		this.hasError = false;
		this._userService.changePassword(this.data.currentPassword, this.data.newPassword).subscribe(response => 
		{
			this.showLoading = false;
			this.dialogRef.close();
		}, error => {
			this.hasError = true;
			this.showLoading = false;
			if (error.error)
				this.errorMessage = error.error;
			else
				this.errorMessage = error.statusText;
		});
	}

	strengthChanged(strength:number) {
		this.currentStrength = strength;
	}
	
	updateMessages() {
		this.hasError = false;
	}
}